import { render, staticRenderFns } from "./DeliveryPricingPackagesTab.vue?vue&type=template&id=65c5636e"
import script from "./DeliveryPricingPackagesTab.vue?vue&type=script&lang=js"
export * from "./DeliveryPricingPackagesTab.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPricingPackagesTab.vue?vue&type=style&index=0&id=65c5636e&prod&lang=scss"
import style1 from "./DeliveryPricingPackagesTab.vue?vue&type=style&index=1&id=65c5636e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports